import { API_endpoints } from "../config";

export const deleteFAQs = async (id: string) => {
    try {
        const response = await fetch(API_endpoints.deleteFAQs, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ id }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Aktualisieren  von FAQs Daten.");
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("Fehler beim Aktualisieren  von FAQs Daten:", error);
        throw error;
    }
};
